import {ActionType} from 'redux-actions';
import {AxiosPromise} from 'axios';
import {FULFILLED} from 'redux-promise-middleware';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';

import {savePayment} from 'reducers/checkout/paymentMethodActive/paymentMethodActive';
import {call, takeEvery} from 'redux-saga/effects';

/**
 * Send analytics on cart update.
 * @param {ActionType<AxiosPromise>} action - took action from start method
 */
export function* onCheckoutUpdated(action: ActionType<AxiosPromise>) {
    const {card} = action.payload.data;

    const cardDataLayer = {
        cardType: card.type,
        cardLevel: card.level,
    };

    yield call(pushDataLayer, {
        'hto-dl': cardDataLayer,
    });
}

/**
 * HTO Checkout analytics root saga.
 */
export default function* gtmCheckoutAnalyticsSaga() {
    yield takeEvery(`${savePayment}_${FULFILLED}`, onCheckoutUpdated);
}
